import { httpAgent, httpWithHeaders } from './axiosConfig'
export function api_post(url, data) {
  return httpAgent({
    method: 'POST',
    url,
    data,
    loading: false,
    all: true
  })
}
export function params_post(url, data) {
  return httpAgent({
    method: 'POST',
    url,
    params: data,
    loading: false,
    all: true,
    qs: true
  })
}
export function stringfy_post(url, data) {
  return httpAgent({
    method: 'POST',
    url,
    data: JSON.stringify(data),
    loading: false,
    all: true
  })
}
export function api_get(url, data) {
  return httpAgent({
    method: 'GET',
    url,
    params: data,
    loading: false,
    all: true
  })
}
export function http_withoutcookie(url, data) {
  return httpAgent({
    method: 'POST',
    url,
    data,
    loading: false,
    all: true,
    withCredentials: false
  })
}
